import { render } from "./TemplateInfo.vue?vue&type=template&id=ae61aea6"
import script from "./TemplateInfo.vue?vue&type=script&lang=js"
export * from "./TemplateInfo.vue?vue&type=script&lang=js"

import "./TemplateInfo.vue?vue&type=style&index=0&id=ae61aea6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__